import type { Template } from "@/types";

export const LA_07_H4_V3: Template[] = [
    {
        id: "la-07-h4v3-01",
        name: "LA 01 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 92, y: 95, width: 242, height: 167, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 270, width: 242, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 95, width: 241, height: 167, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 270, width: 241, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 40, width: 306, height: 449, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1101, y: 40, width: 140, height: 220, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1101, y: 269, width: 140, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-02",
        name: "LA 02 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 92, y: 42, width: 491, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 377, width: 159, height: 113, rotation: 0, imageRotation: 0 },
            { id: "3", x: 259, y: 377, width: 158, height: 113, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 377, width: 158, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 42, width: 306, height: 449, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1101, y: 42, width: 140, height: 221, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1101, y: 271, width: 140, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-03",
        name: "LA 03 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 114, y: 55, width: 448, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 114, y: 339, width: 221, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 339, width: 220, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 55, width: 396, height: 229, rotation: 0, imageRotation: 0 },
            { id: "5", x: 816, y: 292, width: 127, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 951, y: 292, width: 127, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1086, y: 292, width: 126, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-04",
        name: "LA 04 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 132, y: 53, width: 133, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 132, y: 269, width: 133, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 273, y: 53, width: 271, height: 424, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 53, width: 480, height: 295, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 356, width: 155, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 937, y: 356, width: 155, height: 121, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1100, y: 356, width: 154, height: 121, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-05",
        name: "LA 05 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 115, y: 54, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "2", x: 115, y: 202, width: 447, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 54, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 54, width: 396, height: 230, rotation: 0, imageRotation: 0 },
            { id: "5", x: 816, y: 292, width: 127, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 951, y: 292, width: 127, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1086, y: 292, width: 126, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-06",
        name: "LA 06 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 98, y: 53, width: 480, height: 295, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 356, width: 155, height: 121, rotation: 0, imageRotation: 0 },
            { id: "3", x: 261, y: 356, width: 155, height: 121, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 356, width: 154, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 791, y: 53, width: 288, height: 424, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1087, y: 53, width: 147, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1087, y: 269, width: 147, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-07",
        name: "LA 07 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 54, width: 589, height: 423, rotation: 0, imageRotation: 0 },
            { id: "2", x: 719, y: 54, width: 194, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 198, width: 194, height: 136, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 343, width: 194, height: 135, rotation: 0, imageRotation: 0 },
            { id: "5", x: 921, y: 54, width: 258, height: 424, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1187, y: 54, width: 122, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1187, y: 270, width: 122, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-08",
        name: "LA 08 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 63, width: 247, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 255, y: 63, width: 285, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 270, width: 285, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 548, y: 63, width: 257, height: 405, rotation: 0, imageRotation: 0 },
            { id: "5", x: 813, y: 63, width: 285, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 813, y: 270, width: 285, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1106, y: 63, width: 246, height: 405, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-09",
        name: "LA 09 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 63, width: 285, height: 199, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 270, width: 285, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 293, y: 63, width: 251, height: 406, rotation: 0, imageRotation: 0 },
            { id: "4", x: 552, y: 63, width: 250, height: 406, rotation: 0, imageRotation: 0 },
            { id: "5", x: 810, y: 63, width: 250, height: 406, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 63, width: 284, height: 199, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1068, y: 270, width: 284, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-10",
        name: "LA 10 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 118, width: 409, height: 296, rotation: 0, imageRotation: 0 },
            { id: "2", x: 417, y: 118, width: 104, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 270, width: 104, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 118, width: 214, height: 296, rotation: 0, imageRotation: 0 },
            { id: "5", x: 751, y: 118, width: 188, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 751, y: 270, width: 188, height: 144, rotation: 0, imageRotation: 0 },
            { id: "7", x: 947, y: 118, width: 408, height: 296, rotation: 0, imageRotation: 0 }
        ],
    }
];